<template>
  <div style="display: flex; justify-content: space-between">
    <div ref="pie_chart" style="width: 260px; height: 260px"></div>
    <div class="chart_list">
      <div v-for="(c, k) in legendsFilter" :key="k">
        <div class="chart_list_labels">
          <a-badge :color="colors[k]" />
          {{ c.title }}
        </div>
        <div class="chart_list_values">
          <span class="a_n">
            <An :percentFormat="true" :number="c.value" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import An from "@/components/AnimateNumber.vue";

export default {
  components: { An },
  props: {
    graph_data: {
      type: Object,
      required: true,
    },

    timestamp: {
      type: Number,
      required: true,
    },
    event_name: {
      type: String,
      required: false,
      default: "updateData_p",
    },
    translate_key: {
      type: String,
      required: false,
    },
  },
  watch: {
    timestamp() {
      if (this.evt == null) {
        this.evt = new CustomEvent(this.event_name);
      }
      this.$refs.pie_chart.dispatchEvent(this.evt);
    },
  },
  inject: ["colors"],
  data() {
    return {
      legends: [],
      evt: null,
      labels: [],
    };
  },
  methods: {
    createGraph() {
      am4core.options.commercialLicense = true;
      am4core.useTheme(am4themes_animated);
      am4core.options.autoDispose = true;

      var chart = am4core.create(this.$refs.pie_chart, am4charts.PieChart);

      chart.innerRadius = am4core.percent(48);

      chart.language.locale["_thousandSeparator"] = " ";

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "title";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 1;
      pieSeries.slices.template.strokeOpacity = 1;

      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      this.colors.map((color) => {
        pieSeries.colors.list.push(am4core.color(color));
      });

      // This creates initial animation
      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;

      // pieSeries.labels.template.paddingTop = 0;
      // pieSeries.labels.template.paddingBottom = 0;
      // pieSeries.labels.template.fontSize = 10;

      // pieSeries.slices.template.alwaysShowTooltip = true;

      // pieSeries.tooltip.getFillFromObject = false;
      // pieSeries.tooltip.background.fill = am4core.color("#fff");
      // pieSeries.tooltip.label.fill = am4core.color("#000");
      // pieSeries.tooltip.pointerOrientation = "down";
      // pieSeries.tooltip.getStrokeFromObject = true;
      // pieSeries.tooltip.getFillFromObject = false;
      // pieSeries.tooltip.background.strokeWidth = 1;
      // pieSeries.tooltip.background.strokeOpacity = 1;
      // pieSeries.tooltip.background.stroke = am4core.color("#000");
      // pieSeries.tooltip.fontSize = 12;
      // pieSeries.tooltip.fontFamily = "Arial";
      // pieSeries.tooltip.label.interactionsEnabled = true;
      // pieSeries.tooltip.pointerOrientation = "vertical";

      pieSeries.tooltip.label.adapter.add("text", function (text, target) {
        if (target.dataItem) {
          return "{title} : {value}";
        } else {
          return text;
        }
      });

      pieSeries.alignLabels = false;

      var slice = pieSeries.slices.template;
      slice.states.getKey("hover").properties.scale = 1;
      slice.states.getKey("active").properties.shiftRadius = 0;

      // this.setLegends(chart)

      const colorMapping = {
        a: "black", // Red
        c: "black", // Green
        e: "black", // Blue
      };

      Object.entries(this.graph_data.tvals).forEach(([key, val]) => {
        const data = {
          key: key,
          title: this.translate[this.translate_key][key],
          value: val,
          // color: colorMapping[key]
        };
        chart.data.push(data);
        // this.legends.push(data);
      });

      Object.entries(this.graph_data.prcts).forEach(([key, val]) => {
        const data = {
          key: key,
          title: this.translate[this.translate_key][key],
          value: val,
          // color: colorMapping[key]
        };
        // chart.data.push(data);
        this.legends.push(data);
      });

      this.$refs.pie_chart.addEventListener(
        this.event_name,
        () => {
          Object.entries(this.graph_data.tvals).forEach(([key, v]) => {
            var index = chart.data.findIndex((s) => s.key == key);

            if (index != undefined) {
              chart.data[index].value = v;
            }
          });

          chart.invalidateRawData();

          this.legends = [];

          Object.entries(this.graph_data.prcts).forEach(([key, val]) => {
            const data = {
              key: key,
              title: this.translate[this.translate_key][key],
              value: val,
            };
            // chart.data.push(data);
            this.legends.push(data);
          });
        },
        false
      );
    },
    setLegends(chart) {
      chart.legend = new am4charts.Legend();

      chart.legend.itemContainers.template.clickable = false;
      chart.legend.itemContainers.template.focusable = false;
      chart.legend.itemContainers.template.cursorOverStyle =
        am4core.MouseCursorStyle.default;

      var marker = chart.legend.markers.template.children.getIndex(0);
      marker.cornerRadius(12, 12, 12, 12);
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
    },
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
    legendsFilter(){
      return this.legends.filter(l => {
        if(l.value) {
          return l
        }
      })
    }
  },
  mounted() {
    setTimeout(() => {
      this.createGraph();
    }, 100);
  },
};
</script>

<style scoped>
.chart_list {
  width: 274px;
  padding-top: 24px;
}
.chart_list_labels {
  display: inline-block;
  vertical-align: top;
  width: 61%;
  padding: 3px;
}
.chart_list_values {
  display: inline-block;
  vertical-align: top;
  width: 39%;
  padding: 3px;
}
</style>